import { Form, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { authServices } from "../../APIServices/UserData/authServices";
import { useEffect } from "react";

export default function CheckRegistrationSetup({
  setNextPage,
  setName,
  name,
  email,
  setEmail,
  roleType,
  setRoleType,
  setLoader,
  loader,
  cardAnim,
  token,
  setUsePassword,
  setUseSecretKey,
}) {
  const checkRegistrationSetup = async () => {
    setLoader(true)
    let userData = {
      name,
      email,
      roleType
    }
    let data = await authServices.checkRegistrationSetup(userData)
    if (data?.status) {
      setNextPage(data?.status)
      setEmail(data?.email)
      setName(data?.name)
      setRoleType(data?.roleType)
      setUsePassword(data?.usePassword)
      setUseSecretKey(data?.useSecretKey)
    }
    setLoader(false)
  }

  const login = () => {
    setNextPage("startLogin")
    window.location.href = "/login";
  }

  useEffect(() => {
    if (token) {
      setRoleType("individual");
    }
  }, [token]);

  return (
    <>
      <motion.div key="step1" {...cardAnim}>
        <Card
          className="border-0 shadow-lg"
          style={{
            width: 420,
            borderRadius: "18px",
            background: "#ffffff",
          }}
        >
          <Card.Body className="p-4">
            <div className="text-center mb-4">
              <h4 className="fw-bold mb-1">Create your account ✨</h4>
              <small className="text-muted">
                Start securing your passwords in minutes
              </small>
            </div>
            {!token &&
              <Form.Group className="mb-3 floating-group">
                <Form.Select
                  className="interactive-input"
                  style={{ fontSize: 14 }}
                  onChange={(e) => setRoleType(e.target.value)}
                  value={roleType}
                >
                  <option value="">Select Account Type</option>
                  <option value="individual">Individual</option>
                  <option value="organization">Organization</option>
                </Form.Select>
                <Form.Label>Account Type *</Form.Label>
              </Form.Group>
            }

            <Form.Group className="mb-3 floating-group">
              <Form.Control
                type="text"
                required
                placeholder=""
                className="interactive-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Form.Label>Full Name *</Form.Label>
            </Form.Group>

            <Form.Group className="mb-3 floating-group">
              <Form.Control
                type="email"
                required
                disabled={token}
                placeholder=""
                className="interactive-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Form.Label>Email Address *</Form.Label>
            </Form.Group>

            <Form.Group className="hstack gap-2 mb-1">
              <Form.Check type="checkbox" className="small" />
              <small className="text-muted" style={{ fontSize: 12 }}>
                Agree to our{" "}
                <NavLink to="/terms" className="fw-semibold text-decoration-none">
                  Terms & Conditions
                </NavLink>{" "}
                and{" "}
                <NavLink to="/privacy" className="fw-semibold text-decoration-none">
                  Privacy Policy
                </NavLink>.
              </small>
            </Form.Group>

            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="mb-2"
            >
              <Button
                disabled={!name || !email || loader}
                onClick={checkRegistrationSetup}
                className="w-100 py-2 fw-bold btn-gradient"
              >
                Continue <FaArrowRight />
              </Button>
            </motion.div>

            <div style={{ fontSize: 14 }} className="text-end">
              <small className="text-muted">
                Already have an account?{" "}
                <span
                  onClick={login}
                  className="CP fw-bold text-primary"
                >
                  Back to login
                </span>
              </small>
            </div>

          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
